(function (angular) {

    angular.module('app.purchase').filter('choosePlanHeader', function () {
        return function (coverageLevelName) {
            switch (coverageLevelName) {
                case 'Individual':
                    return 'Individual';
                case 'Two Individuals':
                    return '2 Individuals';
                case 'Family' :
                    return '3+ Individuals';
                case '1 Person' :
                    return 'Individual';
                case '2+ People' :
                    return 'FAMILY (TWO +)';
            }
        };
    });

})(angular);